// import TypewriterEffect from "../components/ui/TypewriterEffect";

// const WelcomePage = () => {
//   return (
//     <main className="left-text" aria-label="Welcome Page">
//       <header>
//         <h1 className="text-xl lg:text-2xl font-bold mb-4 text-blue-900">
//           Live a happy and content life!
//         </h1>
//       </header>
//       {/* <TypewriterEffect
//         words={[
//           { text: "I help individuals who want to improve their life" },
//           { text: "and their relationship" },
//           {
//             text: ", through talking therapy"
//           },
//           { text: "and I am here to support you every step of the way." }
//         ]}
//         cursorClassName="left-text text-blue-300"
//       /> */}

//       <p className="text-xl lg:text-xl text-blue-900">
//         I help individuals who want to improve their life and their relationship
//         through talking therapy.
//       </p>

//       <div classname="w-full flex justify-center md:justify-start">
//         <button
//           type="button"
//           className="mt-6 bg-yellow-300 hover:bg-blue-700 text-blue font-bold py-2 px-4 rounded"
//           onClick={() => (window.location.href = "/booking")}
//         >
//           Book a Free 15-Minute Initial Session
//         </button>
//       </div>
//       <div className="flex-shrink-0 flex justify-end w-1/5">
//         <img
//           src={happy_face_one}
//           alt="Happy Face"
//           className="h-auto w-48 lg:w-64"
//         />
//       </div>
//     </main>
//   );
// };

// export default WelcomePage;

// const WelcomePage = () => {
//   return (
//     <main className="relative min-h-screen flex items-center justify-between">
//       {/* Text Section */}
//       <div className="flex-grow flex flex-col items-start justify-center pt-5 pl-16">
//         <h1 className="text-xl lg:text-2xl font-bold mb-4 text-blue-900">
//           Live a happy and content life!
//         </h1>
//         <p className="text-xl lg:text-xl text-blue-900">
//           I help individuals who want to improve their life and their
//           relationship through talking therapy.
//         </p>
//         <div className="mt-6">
//           <button className="bg-yellow-300 hover:bg-blue-700 text-blue font-bold py-2 px-4 rounded">
//             Book a Free 15-Minute Initial Session
//           </button>
//         </div>
//       </div>

//       {/* Image Section */}
//       <div className="flex flex-col justify-between items-end h-full pr-5">
//         {" "}
//         {/* Top-right image */}
//         <img
//           src={happy_face_one}
//           alt="Happy Face One"
//           className="h-auto w-48 lg:w-64 mb-auto"
//         />
//         {/* </div>
//       <div className="absolute right-4 bottom-4">
//         {" "}
//         Bottom-right image */}
//         <img
//           src={happy_face_two}
//           alt="Happy Face Two"
//           className="h-auto w-48 lg:w-64"
//         />
//       </div>
//     </main>
//   );
// };

// export default WelcomePage;

function Home() {
  return (
    <main className="relative min-h-screen flex items-center justify-between">
      {/* Text Section */}
      <div className="flex-grow flex flex-col items-start justify-center pt-5 pl-16">
        <h1 className="text-xl lg:text-2xl font-bold mb-4 text-blue-900">
          Live a happy and content life!
        </h1>
        <p className="text-xl lg:text-xl text-blue-900">
          I help individuals who want to improve their life and their
          relationship through talking therapy.
        </p>
        <div className="mt-6">
          <button className="bg-yellow-300 hover:bg-blue-700 text-blue font-bold py-2 px-4 rounded">
            Book a Free 15-Minute Initial Session
          </button>
        </div>
      </div>

      {/* Image Section */}
      <div className="flex flex-col items-center h-full pr-5">
        {/* Top-Centered Rounded Image */}
        <div className="flex justify-center items-start w-full">
          <img
            src="/happy_face_one.jpg"
            alt="Happy Face One"
            className="h-auto w-48 lg:w-64 rounded-full mt-5"
          />
        </div>
        {/* Bottom-right image */}
        <div className="mt-auto self-end">
          <img
            src="/happy_face_two.jpg"
            alt="Happy Face Two "
            className="h-auto w-48 lg:w-64"
          />
        </div>
      </div>
    </main>
  );
}

export default Home;
